(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["podcast-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('osd-podcast')) {
    customElements.define('osd-podcast', class extends HTMLElement {
      connectedCallback() {
        const audio = this.querySelector('[data-pod-audio]');
        const play = this.querySelector('[data-pod-play]');
        const seek = this.querySelector('[data-pod-seek]');
        const now = this.querySelector('[data-pod-now]');
        const speed = this.querySelector('[data-pod-speed]');
        const follow = this.querySelector('[data-pod-follow]');
        const box = this.querySelector('[data-pod-lines]');
        const lines = [...this.querySelectorAll('.pod__line')];
        const times = lines.map((l) => +l.dataset.t);
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const fmt = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
        let current = -1;
        let dragging = false;
        const load = () => { if (!audio.src) audio.src = this.dataset.src; };
        const toggle = () => { load(); audio.paused ? audio.play() : audio.pause(); };
        const goTo = (t) => { load(); audio.currentTime = t; if (audio.paused) audio.play(); };
        play.addEventListener('click', toggle);
        lines.forEach((l) => l.addEventListener('click', () => goTo(+l.dataset.t)));
        const rates = [1, 1.25, 1.5, 2, 0.75];
        speed.addEventListener('click', () => {
          const r = rates[(rates.indexOf(audio.playbackRate) + 1) % rates.length];
          audio.playbackRate = r;
          speed.textContent = `${r}×`;
        });
        seek.addEventListener('input', () => { dragging = true; now.textContent = fmt(+seek.value); });
        seek.addEventListener('change', () => { dragging = false; goTo(+seek.value); });
        const setPlaying = (on) => {
          this.classList.toggle('is-playing', on);
          play.setAttribute('aria-label', on ? play.dataset.labelPause : play.dataset.labelPlay);
        };
        audio.addEventListener('play', () => {
          setPlaying(true);
          // one podcast at a time on the page
          document.querySelectorAll('osd-podcast audio').forEach((a) => { if (a !== audio) a.pause(); });
        });
        audio.addEventListener('pause', () => setPlaying(false));
        audio.addEventListener('ended', () => setPlaying(false));
        audio.addEventListener('timeupdate', () => {
          const t = audio.currentTime;
          if (!dragging) { seek.value = Math.floor(t); now.textContent = fmt(t); }
          let i = times.length - 1;
          while (i > 0 && times[i] > t) i--;
          if (i === current) return;
          lines[current]?.classList.remove('is-now');
          lines[current]?.removeAttribute('aria-current');
          current = i;
          lines[i].classList.add('is-now');
          lines[i].setAttribute('aria-current', 'true');
          if (follow.checked) {
            const top = lines[i].offsetTop - box.offsetTop - box.clientHeight / 3;
            box.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
